import React from 'react';

interface RadialMotifProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const RadialMotif: React.FC<RadialMotifProps> = ({ size = 200, className = '', style }) => {
  const dashes = 36;
  const radius = size / 2 - 8;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={`${className}`}
      style={style}
      aria-hidden="true"
    >
      {Array.from({ length: dashes }).map((_, i) => {
        const angle = (360 / dashes) * i;
        const rad = (angle * Math.PI) / 180;
        const cx = size / 2;
        const cy = size / 2;
        const x1 = cx + (radius - 6) * Math.cos(rad);
        const y1 = cy + (radius - 6) * Math.sin(rad);
        const x2 = cx + radius * Math.cos(rad);
        const y2 = cy + radius * Math.sin(rad);

        return (
          <line
            key={i}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            opacity={0.3}
          />
        );
      })}
    </svg>
  );
};

export default RadialMotif;
